import {
  ReferencePathDirection,
  ReferenceType,
  type IReference,
  type IReferencePath,
} from '@framework/engine';
import { candidateSelectWidgetObjectName } from './createCandidateSelectFormSchema';
import { getWidgetCandidateColumns } from './form/getWidgetCandidateColumns';
import type { ICandidateWidget } from './ICandidateWidget';

export function getCandidateSelectColumnsReferences(
  path: IReferencePath,
  widget: ICandidateWidget,
): IReference[] {
  return getWidgetCandidateColumns(widget).map(column => ({
    type: ReferenceType.Widget,
    widgetType: null,
    id: `${widget.id}-${column.name}`,
    code: column.name,
    path: [
      ...path,
      {
        direction: ReferencePathDirection.Child,
        code: candidateSelectWidgetObjectName(widget.code),
      },
    ],
    field: { type: column.type },
    label: `${widget.code}: ${column.label}`,
  })) as IReference[];
}
